/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowIteration = createReactComponent("arrow-iteration", "IconArrowIteration", [
  ["path", { d: "M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5", key: "svg-0" }],
  ["path", { d: "M3 16h18", key: "svg-1" }],
  ["path", { d: "M18 13l3 3l-3 3", key: "svg-2" }]
]);

export { IconArrowIteration as default };
//# sourceMappingURL=IconArrowIteration.js.map
